export enum ReviewSubjectType {
  Waiter = 'waiter',
  MenuItem = 'menuItem',
  Venue = 'venue',
}
